import * as React from "react";

import {
  Image as ImageComponent,
  ImageProps,
} from "../../components/Image/Image";
import { withAction } from "../Actions/withActions";

class Image extends React.PureComponent<ImageProps> {
  render() {
    return <ImageComponent {...this.props} />;
  }
}

export default withAction(Image);
